<template lang='pug'>
.line
  .line__item(
    v-if="$slots.link"
    :class="{line__item_half: $slots.link && $slots.cert}"
  )
    slot(name="link")
  .line__item(
    v-if="$slots.cert"
    :class="[{line__item_half: $slots.link && $slots.cert}, {line__item_right: $slots.link}]"
  )
    slot(name="cert")
</template>

<script>
export default {
  name: 'CompPartsHeaderLine',
};
</script>

<style lang='stylus' scoped>
.line
  height 100%
  display flex

  &__item
    flex-basis 100%
    display flex
    align-items center

    &_half
      flex-basis 50%

    &_right
      justify-content flex-end

  &__item /deep/ a
    margin-right 8px
    padding-right 8px
    font-size 12px
    color #1f1555
    text-decoration none
    position relative

    &:hover
      text-decoration underline

    &::after
      content ''
      width 1px
      height 14px
      display block
      background-color #8482d3
      position absolute
      top -1px
      right -1px

    &:last-child
      margin-right 0
      padding-right 0

      &::after
        display none
</style>



// WEBPACK FOOTER //
// Line.vue?b21759e2